var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.6074,
    y1: 384.5858,
    x2: 432.5537,
    y2: 26.6395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD8D8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9981,
    style: {
      stopColor: "#FFB2B2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M495.51,134.513C482.382,50.528,399.464-24.323,308.926,7.47 C274.87,19.429,259.56,56.328,153.398,42.337C51.391,28.895-17.511,156.484,30.061,242.57 c32.967,59.656,108.287,90.386,118.892,166.884c3.525,25.426,6.16,53.177,23.149,72.425 c36.102,40.903,122.218,44.991,132.806-18.147C327.804,327.198,517.724,276.62,495.51,134.513z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0000CB"
    },
    d: "M457.703,218.498l-14.621-7.929c1.487-9.085,1.603-18.46,0.246-27.817l14.756-7.675 c2.126-1.106,3.063-3.646,2.166-5.867l-11.725-29.021c-0.897-2.222-3.336-3.397-5.634-2.716l-15.946,4.729 c-5.524-7.673-12.117-14.33-19.497-19.832l5.01-15.861c0.722-2.285-0.412-4.745-2.617-5.681l-28.813-12.23 c-2.206-0.936-4.762-0.043-5.905,2.064l-7.93,14.622c-9.082-1.48-18.453-1.605-27.807-0.242l-7.675-14.756 c-1.106-2.126-3.646-3.063-5.867-2.166l-29.021,11.725c-2.222,0.897-3.397,3.336-2.716,5.634l4.729,15.946 c-7.676,5.517-14.33,12.117-19.835,19.49l-15.861-5.01c-2.285-0.722-4.745,0.411-5.681,2.617l-12.23,28.813 c-0.936,2.206-0.043,4.762,2.064,5.905l14.622,7.93c-1.487,9.085-1.605,18.453-0.249,27.81l-14.749,7.672 c-2.126,1.106-3.063,3.646-2.166,5.867l11.725,29.021c0.898,2.222,3.336,3.397,5.634,2.716l15.939-4.727 c5.524,7.673,12.12,14.337,19.5,19.839l-5.009,15.861c-0.722,2.285,0.412,4.745,2.618,5.681l28.811,12.225 c2.205,0.936,4.761,0.043,5.903-2.062l7.933-14.617c9.082,1.48,18.45,1.598,27.807,0.242l7.675,14.756 c1.106,2.126,3.646,3.063,5.867,2.166l29.021-11.725c2.221-0.898,3.397-3.336,2.716-5.634l-4.73-15.946 c7.673-5.524,14.33-12.117,19.835-19.49l15.86,5.004c2.284,0.721,4.743-0.412,5.679-2.617l12.233-28.807 C460.703,222.197,459.81,219.641,457.703,218.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0000CB"
    },
    d: "M63.848,256.492c0.629,1.728,2.468,2.695,4.248,2.234l12.349-3.198 c4.031,6.032,8.91,11.319,14.423,15.736l-4.266,12.029c-0.615,1.733,0.189,3.65,1.855,4.427l21.766,10.146 c1.666,0.777,3.65,0.16,4.582-1.424l6.474-10.997c6.925,1.378,14.106,1.72,21.318,0.93l5.49,11.521 c0.791,1.66,2.714,2.447,4.442,1.818l22.569-8.214c1.728-0.629,2.695-2.468,2.234-4.248l-3.2-12.355 c6.032-4.031,11.313-8.908,15.732-14.415l12.028,4.262c1.733,0.614,3.648-0.189,4.425-1.855l10.152-21.764 c0.777-1.667,0.161-3.651-1.424-4.584l-11-6.472c1.384-6.927,1.723-14.113,0.934-21.325l11.521-5.49 c1.66-0.791,2.447-2.714,1.818-4.441l-8.214-22.569c-0.629-1.728-2.468-2.695-4.247-2.234l-12.355,3.2 c-4.031-6.032-8.908-11.313-14.421-15.73l4.266-12.029c0.615-1.733-0.188-3.649-1.855-4.427l-21.768-10.151 c-1.667-0.777-3.651-0.161-4.583,1.424l-6.473,11c-6.925-1.378-14.108-1.725-21.318-0.93l-5.49-11.521 c-0.791-1.66-2.714-2.447-4.441-1.818l-22.569,8.214c-1.728,0.629-2.695,2.468-2.234,4.248l3.2,12.355 c-6.034,4.025-11.313,8.908-15.732,14.415l-12.029-4.266c-1.733-0.615-3.649,0.188-4.427,1.855l-10.151,21.768 c-0.777,1.667-0.161,3.651,1.424,4.583l11,6.473c-1.383,6.927-1.725,14.108-0.936,21.319l-11.516,5.488 c-1.66,0.791-2.447,2.714-1.818,4.441L63.848,256.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0000CB"
    },
    d: "M416.232,437.36l-26.215-2.515c-3.817-15.596-9.963-30.271-18.084-43.63l16.762-20.314 c3.28-3.975,3.002-9.792-0.642-13.436l-34.884-34.885c-3.644-3.644-9.461-3.922-13.436-0.642L319.419,338.7 c-13.359-8.108-28.034-14.267-43.63-18.071l-2.515-26.214c-0.492-5.129-4.801-9.045-9.954-9.045h-49.332 c-5.153,0-9.462,3.916-9.954,9.045l-2.515,26.215c-15.596,3.804-30.271,9.963-43.63,18.071l-20.314-16.762 c-3.975-3.28-9.791-3.002-13.435,0.642l-34.885,34.885c-3.644,3.644-3.922,9.461-0.642,13.436l16.762,20.314 c-8.121,13.359-14.267,28.034-18.084,43.63l-26.202,2.515c-5.129,0.492-9.045,4.801-9.045,9.954v19.904c0,2.761,2.239,5,5,5 h363.233c2.761,0,5-2.239,5-5v-19.904C425.277,442.161,421.362,437.852,416.232,437.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9393FF"
    },
    d: "M460.25,145.21l-11.725-29.02c-0.898-2.222-3.336-3.398-5.634-2.716l-15.946,4.73 c-5.524-7.673-12.117-14.33-19.497-19.832l5.009-15.861c0.722-2.285-0.411-4.745-2.617-5.681l-28.813-12.23 c-2.206-0.936-4.762-0.043-5.905,2.064l-7.93,14.622c-9.082-1.48-18.453-1.605-27.807-0.242l-7.675-14.756 c-1.106-2.126-3.646-3.063-5.867-2.166l-29.021,11.725c-2.222,0.898-3.397,3.336-2.716,5.634l4.73,15.946 c-7.676,5.517-14.329,12.117-19.835,19.49l-15.861-5.009c-2.285-0.722-4.745,0.411-5.681,2.617l-12.23,28.813 c-0.936,2.206-0.043,4.762,2.064,5.905l14.622,7.93c-1.487,9.085-1.605,18.453-0.249,27.81l-14.749,7.672 c-2.126,1.106-3.063,3.646-2.166,5.867l11.725,29.021c0.898,2.222,3.336,3.397,5.634,2.716l15.939-4.727 c5.524,7.673,12.12,14.337,19.5,19.839l-5.009,15.861c-0.722,2.285,0.412,4.745,2.618,5.681l28.811,12.225 c2.205,0.936,4.761,0.043,5.903-2.063l7.932-14.617c9.082,1.48,18.45,1.598,27.807,0.242l7.675,14.756 c1.106,2.126,3.646,3.063,5.867,2.166l29.021-11.725c2.222-0.898,3.398-3.336,2.716-5.634l-4.73-15.946 c7.673-5.524,14.33-12.117,19.835-19.49l15.86,5.004c2.285,0.721,4.743-0.412,5.679-2.617l12.233-28.807 c0.937-2.206,0.043-4.763-2.063-5.905l-14.621-7.929c1.487-9.085,1.603-18.46,0.246-27.817l14.756-7.675 C460.21,149.971,461.148,147.431,460.25,145.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0000CB",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M443.328,158.755l14.754-7.673c2.126-1.106,3.064-3.646,2.166-5.867l-11.726-29.022c-0.898-2.222-3.337-3.398-5.634-2.716 l-15.943,4.729c-5.522-7.674-12.118-14.331-19.494-19.835l5.007-15.86c0.721-2.285-0.412-4.744-2.617-5.68L381.029,64.6 c-2.206-0.936-4.762-0.043-5.904,2.063l-7.93,14.619c-9.083-1.482-18.454-1.602-27.81-0.244l-7.673-14.754 c-1.106-2.126-3.646-3.064-5.867-2.166l-29.022,11.725c-2.222,0.898-3.398,3.337-2.716,5.634l4.729,15.943 c-7.674,5.522-14.331,12.118-19.835,19.494l-15.86-5.007c-2.285-0.721-4.744,0.412-5.68,2.617l-12.23,28.812 c-0.936,2.206-0.043,4.762,2.063,5.904l14.619,7.93c-1.482,9.083-1.602,18.454-0.244,27.81l-14.754,7.673 c-2.126,1.106-3.064,3.646-2.166,5.867l11.726,29.022c0.898,2.222,3.337,3.398,5.634,2.716l15.943-4.729 c5.522,7.674,12.118,14.331,19.494,19.835l-5.007,15.86c-0.721,2.285,0.412,4.744,2.617,5.68l28.813,12.23 c2.206,0.936,4.762,0.043,5.904-2.063l7.93-14.619c9.083,1.482,18.454,1.602,27.81,0.244l7.673,14.754 c1.106,2.126,3.646,3.064,5.867,2.166l29.022-11.725c2.222-0.898,3.398-3.337,2.716-5.634l-4.729-15.943 c7.674-5.522,14.331-12.118,19.835-19.494l15.86,5.007c2.285,0.721,4.744-0.412,5.68-2.617l12.23-28.813 c0.936-2.206,0.043-4.762-2.063-5.904l-14.619-7.93"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6C6CFF"
    },
    d: "M352.51,241.235c-38.313,0-69.368-31.066-69.368-69.368c0-38.313,31.055-69.368,69.368-69.368 c38.302,0,69.357,31.055,69.357,69.368C421.867,210.169,390.812,241.235,352.51,241.235z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4DFF"
    },
    d: "M352.509,225.853c-29.818,0-53.986-24.177-53.986-53.986 c0-29.818,24.169-53.986,53.986-53.986c29.809,0,53.977,24.169,53.977,53.986 C406.487,201.675,382.318,225.853,352.509,225.853z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6C6C"
    },
    d: "M222.319,174.813l-8.214-22.569c-0.629-1.728-2.468-2.695-4.248-2.234l-12.355,3.2 c-4.031-6.032-8.908-11.313-14.421-15.73l4.266-12.029c0.615-1.733-0.188-3.649-1.855-4.426l-21.768-10.151 c-1.667-0.777-3.651-0.16-4.583,1.424l-6.473,11c-6.925-1.378-14.108-1.725-21.318-0.93l-5.49-11.521 c-0.791-1.66-2.714-2.447-4.441-1.818l-22.569,8.214c-1.728,0.629-2.695,2.468-2.234,4.248l3.2,12.355 c-6.034,4.025-11.313,8.908-15.732,14.415l-12.029-4.266c-1.733-0.615-3.649,0.188-4.426,1.855l-10.151,21.768 c-0.777,1.667-0.16,3.651,1.424,4.583l11,6.473c-1.383,6.927-1.725,14.108-0.936,21.32l-11.516,5.488 c-1.66,0.791-2.447,2.714-1.818,4.441l8.214,22.569c0.629,1.728,2.468,2.695,4.247,2.234l12.349-3.198 c4.031,6.032,8.91,11.319,14.423,15.736l-4.266,12.029c-0.615,1.733,0.189,3.65,1.855,4.427l21.766,10.146 c1.666,0.777,3.65,0.16,4.582-1.424l6.474-10.996c6.925,1.378,14.106,1.72,21.318,0.93l5.49,11.521 c0.791,1.66,2.714,2.447,4.441,1.818l22.569-8.214c1.728-0.629,2.695-2.468,2.234-4.248l-3.2-12.355 c6.032-4.031,11.313-8.908,15.732-14.415l12.028,4.262c1.733,0.614,3.648-0.189,4.425-1.855l10.152-21.764 c0.777-1.667,0.161-3.651-1.424-4.584l-11-6.472c1.383-6.927,1.723-14.113,0.934-21.325l11.521-5.49 C222.161,178.463,222.948,176.541,222.319,174.813z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0000CB",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M208.98,184.747l11.52-5.489c1.66-0.791,2.447-2.714,1.818-4.441l-8.215-22.569c-0.629-1.728-2.468-2.695-4.248-2.234 l-12.353,3.2c-4.029-6.032-8.909-11.315-14.418-15.733l4.265-12.028c0.614-1.733-0.189-3.649-1.855-4.426l-21.768-10.15 c-1.666-0.777-3.65-0.161-4.583,1.424l-6.473,10.998c-6.926-1.38-14.108-1.723-21.32-0.932l-5.489-11.52 c-0.791-1.66-2.714-2.447-4.441-1.818l-22.569,8.215c-1.728,0.629-2.695,2.468-2.234,4.248l3.2,12.353 c-6.033,4.029-11.315,8.909-15.733,14.418l-12.028-4.264c-1.733-0.614-3.649,0.189-4.426,1.855l-10.15,21.768 c-0.777,1.666-0.161,3.65,1.424,4.583l10.998,6.473c-1.38,6.926-1.723,14.109-0.932,21.32l-11.52,5.489 c-1.66,0.791-2.447,2.714-1.818,4.441l8.215,22.569c0.629,1.728,2.468,2.695,4.248,2.234l12.353-3.2 c4.029,6.033,8.909,11.315,14.418,15.733l-4.265,12.028c-0.614,1.733,0.189,3.649,1.855,4.426l21.768,10.15 c1.666,0.777,3.65,0.161,4.583-1.424l6.473-10.998c6.925,1.38,14.108,1.723,21.32,0.932l5.489,11.52 c0.791,1.66,2.714,2.447,4.441,1.818l22.569-8.215c1.728-0.629,2.695-2.468,2.234-4.248l-3.2-12.353 c6.032-4.029,11.315-8.909,15.733-14.418l12.028,4.265c1.733,0.614,3.649-0.189,4.426-1.855l10.15-21.768 c0.777-1.666,0.161-3.65-1.424-4.583l-10.998-6.473C209.428,199.141,209.771,191.958,208.98,184.747z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D4D"
    },
    d: "M138.984,239.772c-26.181,0-47.402-21.229-47.402-47.402 c0-26.181,21.221-47.402,47.402-47.402c26.173,0,47.394,21.221,47.394,47.402 C186.377,218.543,165.157,239.772,138.984,239.772z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.983,226.621c-18.918,0-34.251-15.339-34.251-34.251 c0-18.918,15.334-34.251,34.251-34.251c18.912,0,34.245,15.333,34.245,34.251 C173.228,211.282,157.895,226.621,138.983,226.621z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFAA66"
    },
    cx: 352.499,
    cy: 171.865,
    r: 40.307
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 337.791,171.276 347.989,181.473 367.206,162.256 \t\t\t\t\t"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9393FF"
    },
    d: "M52.044,423.314v19.904c0,2.761,2.239,5,5,5h363.233c2.761,0,5-2.239,5-5v-19.904 c0-5.153-3.916-9.462-9.045-9.954l-26.215-2.515c-3.817-15.596-9.963-30.271-18.084-43.63l16.762-20.314 c3.28-3.975,3.002-9.792-0.642-13.436l-34.885-34.885c-3.644-3.644-9.461-3.922-13.436-0.642L319.42,314.7 c-13.359-8.108-28.034-14.267-43.63-18.071l-2.515-26.214c-0.492-5.129-4.801-9.045-9.954-9.045h-49.332 c-5.153,0-9.462,3.916-9.954,9.045l-2.515,26.214c-15.596,3.804-30.271,9.963-43.63,18.071l-20.314-16.762 c-3.975-3.28-9.792-3.002-13.436,0.642l-34.885,34.885c-3.644,3.644-3.922,9.461-0.642,13.436l16.762,20.314 c-8.121,13.359-14.267,28.034-18.084,43.63l-26.202,2.515C55.959,413.852,52.044,418.161,52.044,423.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8282FF"
    },
    d: "M238.658,319.83c-70.793,0-128.388,57.595-128.388,128.388h256.775 C367.045,377.425,309.451,319.83,238.658,319.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC498"
    },
    d: "M347.049,448.221h-216.78c0-59.86,48.53-108.39,108.39-108.39 C298.519,339.831,347.049,388.361,347.049,448.221z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA66"
    },
    d: "M329.229,448.221c0-0.08,0.01-0.16,0.01-0.23c0-50.04-40.56-90.59-90.58-90.59 c-50.03,0-90.59,40.55-90.59,90.59c0,0.07,0.01,0.15,0.01,0.23h-17.81c0-59.86,48.53-108.39,108.39-108.39 c59.86,0,108.39,48.53,108.39,108.39H329.229z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0000CB",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M285.841,299.466c-3.307-1.049-6.653-2.011-10.052-2.842l-2.513-26.21c-0.492-5.13-4.801-9.046-9.954-9.046h-49.334 c-5.153,0-9.462,3.916-9.954,9.045l-2.514,26.211c-15.596,3.813-30.275,9.963-43.633,18.075l-20.312-16.757 c-3.975-3.279-9.791-3.001-13.435,0.643l-34.884,34.884c-3.644,3.644-3.922,9.46-0.643,13.435l16.758,20.313 c-8.112,13.359-14.262,28.038-18.076,43.633l-26.21,2.514c-5.13,0.492-9.045,4.801-9.045,9.954v19.9c0,2.761,2.239,5,5,5 h363.233c2.761,0,5-2.239,5-5v-19.9c0-5.153-3.916-9.463-9.045-9.954l-26.21-2.514c-3.813-15.596-9.963-30.275-18.076-43.633 l16.757-20.312c3.279-3.975,3.001-9.791-0.643-13.435l-34.884-34.884c-3.644-3.644-9.46-3.922-13.435-0.643L319.423,314.7 c-2.462-1.495-4.983-2.9-7.532-4.259"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0000CB",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M130.27,448.218c0-59.861,48.527-108.388,108.388-108.388c59.861,0,108.388,48.527,108.388,108.388"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF9C33",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 270.738,
    y1: 396.656,
    x2: 238.654,
    y2: 396.656
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF6C6C",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 221.718,
    y1: 396.714,
    x2: 221.718,
    y2: 396.597
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF6C6C",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 206.577,
    y1: 396.714,
    x2: 206.577,
    y2: 396.597
  }))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF9C33",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 270.738,
    y1: 417.085,
    x2: 206.577,
    y2: 417.085
  })))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FF9C33",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 66.259,
    cy: 77.72,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FF6C6C",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 260.707,
    cy: 46.406,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#FF6C6C",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 55.416,300.799 58.013,308.791 66.416,308.791 59.618,313.73 62.215,321.722 55.416,316.783 48.618,321.722 51.215,313.73  44.416,308.791 52.82,308.791 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#FF9C33",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 449.587,363.101 452.184,371.093 460.587,371.093 453.789,376.032 456.386,384.024 449.587,379.085 442.789,384.024  445.386,376.032 438.587,371.093 446.991,371.093 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#6C6CFF",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 215.693,69.567 218.29,77.559 226.693,77.559 219.894,82.498 222.491,90.49 215.693,85.551 208.894,90.49 211.491,82.498  204.693,77.559 213.096,77.559 \t\t"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalSystem);
export default __webpack_public_path__ + "static/media/externalSystem.789d1d1cf1e966287d792dc431e3b4fa.svg";
export { ForwardRef as ReactComponent };